import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styles, { errorScope } from './styles'

const FormErrorNotification = ({ scope, text }) => <div className={cx(styles.error, errorScope(scope))}>{text}</div>

FormErrorNotification.propTypes = {
  text: PropTypes.string.isRequired,
  scope: PropTypes.oneOf(['', 'generalTop', 'generalMiddle', 'fieldTop', 'fieldBottom']),
}

FormErrorNotification.defaultProps = {
  scope: 'generalTop',
}

export default FormErrorNotification
